import NavButtons from 'components/Software/macOS/NavButtons';
import ForumBox from 'components/Software/macOS/Sighthound/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};